export default __webpack_public_path__ + "static/media/six.692861d8.jfif";